import { filterWidgetEvent } from '@client/foundation/shared/utils/filter-widget-event';
import { WidgetPayload } from '@client/widgets/widget.types';
import { useEffect } from 'react';
import { useWidget } from '@client/widgets/widget.hook';
import { useWindow } from '@client/window/window.hook';
import { useFileDownload } from './file-download.hook';

export const useFileDownloadFormEvents = () => {
  const { openWidget$ } = useWidget();
  const { openWindow, closeWindow } = useWindow();
  const { downloadFile } = useFileDownload();

  useEffect(() => {
    const subscription = openWidget$()
      .pipe(
        filterWidgetEvent<WidgetPayload, 'FileDownloadForm'>('FileDownloadForm')
      )
      .subscribe(({ type }) => {
        openWindow({
          type: 'FileDownloadForm',
          componentProps: {
            onSubmit: (state) => {
              downloadFile(
                state.exchangeId,
                state.symbol,
                state.timeframe,
                state.historicalDays,
                state.fromDate,
                state.toDate
              );
            }
          }
        });
      });

    return () => {
      subscription.unsubscribe();
    };
  }, [openWindow, closeWindow, downloadFile, openWidget$]);
};
